import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/default/images/giftbox.svg'
import _imports_1 from '@/assets/default/images/giftbox-closed.svg'
import _imports_2 from '@/assets/default/images/star-left.svg'
import _imports_3 from '@/assets/default/images/star-right.svg'


const _hoisted_1 = {
  class: "flex flex-col items-center py-5 text-gray-700",
  style: {"font-family":"Noto Sans JP"}
}
const _hoisted_2 = {
  key: 0,
  class: "mb-3",
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  class: "mb-3",
  src: _imports_1
}
const _hoisted_4 = { class: "flex flex-row justify-center items-end relative" }
const _hoisted_5 = { class: "flex flex-col items-center font-black" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, " LINE Pay残高 ", -1)
const _hoisted_7 = { class: "relative z-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "z-0 absolute -inset-x-0.5 bottom-0 top-2/3 rounded-sm bg-green-400 opacity-30" }, null, -1)
const _hoisted_9 = { class: "relative z-10" }
const _hoisted_10 = { class: "text-2xl" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "相当", -1)
const _hoisted_12 = {
  key: 0,
  class: "text-line"
}
const _hoisted_13 = {
  key: 1,
  class: "text-line"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.giftOpen)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (_openBlock(), _createElementBlock("img", _hoisted_3)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        class: _normalizeClass(["relative bottom-3", [
          !_ctx.giftOpen && 'invisible'
        ]]),
        src: _imports_2
      }, null, 2),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.amount.toLocaleString()) + "円", 1),
            _hoisted_11
          ])
        ]),
        (_ctx.giftOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, " ゲット! "))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, " プレゼント "))
      ]),
      _createElementVNode("img", {
        class: _normalizeClass(["relative bottom-3", [
          !_ctx.giftOpen && 'invisible'
        ]]),
        src: _imports_3
      }, null, 2)
    ])
  ]))
}